/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ action: NonNullable<unknown> }} Admin_Ai_Chat_Approval_AskInputs */

const de_admin_ai_chat_approval_ask = /** @type {(inputs: Admin_Ai_Chat_Approval_AskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Der Assistent möchte ${i?.action}. Erlauben?`)
};

const es_admin_ai_chat_approval_ask = /** @type {(inputs: Admin_Ai_Chat_Approval_AskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El asistente quiere ${i?.action}. ¿Permitir?`)
};

const fr_admin_ai_chat_approval_ask = /** @type {(inputs: Admin_Ai_Chat_Approval_AskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`L'assistant souhaite ${i?.action}. Autoriser ?`)
};

const nl_admin_ai_chat_approval_ask = /** @type {(inputs: Admin_Ai_Chat_Approval_AskInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`De assistent wil ${i?.action}. Toestaan?`)
};

/** @type {(inputs: Admin_Ai_Chat_Approval_AskInputs) => LocalizedString} */
const en_admin_ai_chat_approval_ask = () => /** @type {LocalizedString} */ ('admin.ai_chat.approval_ask')

/** @type {(inputs: Admin_Ai_Chat_Approval_AskInputs) => LocalizedString} */
const it_admin_ai_chat_approval_ask = en_admin_ai_chat_approval_ask;

/** @type {(inputs: Admin_Ai_Chat_Approval_AskInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_approval_ask = en_admin_ai_chat_approval_ask;

/** @type {(inputs: Admin_Ai_Chat_Approval_AskInputs) => LocalizedString} */
const pl_admin_ai_chat_approval_ask = en_admin_ai_chat_approval_ask;

/** @type {(inputs: Admin_Ai_Chat_Approval_AskInputs) => LocalizedString} */
const hu_admin_ai_chat_approval_ask = en_admin_ai_chat_approval_ask;

/** @type {(inputs: Admin_Ai_Chat_Approval_AskInputs) => LocalizedString} */
const ro_admin_ai_chat_approval_ask = en_admin_ai_chat_approval_ask;

/**

* @param {Admin_Ai_Chat_Approval_AskInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_approval_ask = /** @type {((inputs: Admin_Ai_Chat_Approval_AskInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Approval_AskInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_approval_ask(inputs)
	if (locale === "de") return de_admin_ai_chat_approval_ask(inputs)
	if (locale === "es") return es_admin_ai_chat_approval_ask(inputs)
	if (locale === "fr") return fr_admin_ai_chat_approval_ask(inputs)
	if (locale === "nl") return nl_admin_ai_chat_approval_ask(inputs)
	if (locale === "it") return it_admin_ai_chat_approval_ask(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_approval_ask(inputs)
	if (locale === "pl") return pl_admin_ai_chat_approval_ask(inputs)
	if (locale === "hu") return hu_admin_ai_chat_approval_ask(inputs)
	return ro_admin_ai_chat_approval_ask(inputs)
});
export { admin_ai_chat_approval_ask as "admin.ai_chat.approval_ask" }